"use strict";
/**
 * Copyright © 2020 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withIframeFormSrcSnippet = exports.withIframeFormHeightSnippet = exports.withIframeFormHeader = exports.useIframeBodilessOptions = exports.withoutPointerEvents = exports.asBaseBodilessIframe = void 0;

var react_1 = __importStar(require("react"));

var core_1 = require("@bodiless/core");

var fclasses_1 = require("@bodiless/fclasses");

var lodash_1 = require("lodash");

var withFormSnippet_1 = __importDefault(require("./withFormSnippet"));

var withFormHeader_1 = __importDefault(require("./withFormHeader")); // Options used to create an edit button.


var options = {
  icon: 'settings',
  groupLabel: 'IFrame',
  label: 'Settings',
  name: 'iframe-settings',
  global: false,
  local: true,
  Wrapper: 'div',
  useCompoundForm: function useCompoundForm() {
    return true;
  },
  renderForm: function renderForm() {
    return true;
  }
};

var useIframeBodilessOptions = function useIframeBodilessOptions() {
  return options;
};

exports.useIframeBodilessOptions = useIframeBodilessOptions;
var withoutPointerEvents = fclasses_1.addProps({
  style: {
    pointerEvents: 'none'
  }
});
exports.withoutPointerEvents = withoutPointerEvents;

var isNonNegativeNumber = function isNonNegativeNumber(value) {
  return /^\d+$/.test(value);
};

var withHeightSnippet = withFormSnippet_1.default({
  nodeKeys: 'height',
  defaultData: {
    height: ''
  },
  snippetOptions: {
    renderForm: function renderForm(_a) {
      var formState = _a.formState;
      var errors = formState.errors;

      var _b = core_1.useMenuOptionUI(),
          ComponentFormLabel = _b.ComponentFormLabel,
          ComponentFormText = _b.ComponentFormText,
          ComponentFormWarning = _b.ComponentFormWarning;

      var validate = react_1.useCallback(function (value) {
        return value && !isNonNegativeNumber(value) ? 'Height must be a non-negative number.' : undefined;
      }, []);
      return react_1.default.createElement(react_1.default.Fragment, {
        key: "height"
      }, react_1.default.createElement(ComponentFormLabel, {
        htmlFor: "height"
      }, "Height (in pixels)"), react_1.default.createElement(ComponentFormText, {
        field: "height",
        validate: validate,
        validateOnChange: true,
        validateOnBlur: true
      }), errors && errors.height && react_1.default.createElement(ComponentFormWarning, null, errors.height));
    }
  }
});
exports.withIframeFormHeightSnippet = withHeightSnippet;
var withSrcSnippet = withFormSnippet_1.default({
  nodeKeys: 'src',
  defaultData: {
    src: ''
  },
  snippetOptions: {
    renderForm: function renderForm() {
      var _a = core_1.useMenuOptionUI(),
          ComponentFormLabel = _a.ComponentFormLabel,
          ComponentFormText = _a.ComponentFormText;

      return react_1.default.createElement(react_1.default.Fragment, {
        key: "src"
      }, react_1.default.createElement(ComponentFormLabel, {
        htmlFor: "src"
      }, "URL"), react_1.default.createElement(ComponentFormText, {
        field: "src"
      }));
    }
  }
});
exports.withIframeFormSrcSnippet = withSrcSnippet;
var withIframeFormHeader = withFormHeader_1.default({
  title: 'Iframe Configuration'
});
exports.withIframeFormHeader = withIframeFormHeader;

var asBaseBodilessIframe = function asBaseBodilessIframe(nodeKeys, defaultData, useOverrides) {
  return lodash_1.flowRight(core_1.ifEditable(withoutPointerEvents), core_1.asBodilessComponent(useIframeBodilessOptions())(nodeKeys, defaultData, useOverrides));
};

exports.asBaseBodilessIframe = asBaseBodilessIframe;

var asBodilessIframe = function asBodilessIframe(nodeKeys, defaultData, useOverrides) {
  return lodash_1.flowRight(asBaseBodilessIframe(nodeKeys, defaultData, useOverrides), withIframeFormHeader, withSrcSnippet, withHeightSnippet);
};

exports.default = asBodilessIframe;